<script context="module">
	import { z } from "zod";
	export const name = "Orizontal";
	export const CustomFields = z.object({
		show_summary: z.boolean().optional(),
	});
</script>

<script>
	import { getContext } from "svelte";
	import ImageView from "@reperio-news/core.components/ImageView.svelte";
	import Kicker from "./Kicker.svelte";
	import Stamp from "./Stamp.svelte";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	const c = getContext("parentBlockColumnCount");

	$: content = data && data.content;
	$: cf = (data && data.custom_fields) || {};
	$: showSummary = cf.show_summary !== false;
	// single-column context → the wide variant (bigger image, larger title)
	$: wide = !$c || $c === 1;
</script>

{#if content}
	<article class="af-card af-item af-item--horizontal" class:af-card--wide={wide}>
		{#if content.poster}
			<div class="af-card__media af-dim">
				<ImageView
					src={content.poster}
					crop={content.poster.crop}
					alt={content.title}
					width={wide ? 800 : 370}
					height={wide ? 533 : 247}
					widths={wide ? [800, 600, 400] : [370, 185]}
					heights={wide ? [533, 400, 267] : [247, 124]}
					fit="cover"
					loading="lazy"
				/>
			</div>
		{/if}
		<div class="af-card__body">
			<Kicker {content} />
			<h3 class="af-card__title"><a href={content.url}>{content.title}</a></h3>
			{#if showSummary && content.summary}
				<p class="af-card__summary">{content.summary}</p>
			{/if}
			<Stamp {content} />
		</div>
	</article>
{/if}

<style lang="scss">
	@use "../../styles/mixins" as m;

	.af-card {
		@include m.af-card;
		display: grid;
		grid-template-columns: 112px minmax(0, 1fr);
	}

	.af-card__media {
		position: relative;
		height: 100%;
		min-height: 7rem;
		overflow: hidden;
		background: var(--af-surface-sunk);

		:global(picture),
		:global(img) {
			position: absolute;
			inset: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.af-card__body {
		display: flex;
		flex-direction: column;
		gap: var(--af-space-2);
		padding: var(--af-space-4);
		min-width: 0;
	}

	.af-card__title {
		font: 600 var(--af-text-h3) / var(--af-leading-tight) var(--af-font-serif);
		color: var(--af-ink);
		text-wrap: balance;

		a {
			@include m.af-stretched-link;
			@include m.af-clamp(3);
		}
	}

	.af-card__summary {
		display: none;
		font-size: var(--af-text-body-sm);
		line-height: 1.5;
		color: var(--af-ink-muted);
		@include m.af-clamp(2);
	}

	.af-card :global(.af-item__stamp) {
		margin-top: auto;
		padding-top: var(--af-space-2);
	}

	@media (min-width: 768px) {
		.af-card {
			grid-template-columns: 185px minmax(0, 1fr);
		}

		.af-card__media {
			min-height: 9rem;
		}

		.af-card--wide {
			grid-template-columns: minmax(0, 2fr) minmax(0, 3fr);
		}

		.af-card__body {
			padding: var(--af-space-6);
		}

		.af-card__summary,
		.af-card--wide .af-card__summary {
			display: -webkit-box;
		}

		.af-card--wide .af-card__title {
			font-size: var(--af-text-h2);
		}
	}
</style>
